import React from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import Tx from "../Tx";

export const ASIDE_TYPES = {
    LIST_OF_FIRMWARES: "LIST_OF_FIRMWARES",
    UPLOAD_FIRMWARE: "UPLOAD_FIRMWARE",
    SENSOR_MANUFACTURER_TYPE: "SENSOR_MANUFACTURER_TYPE"
};

const WrapperStyled = styled.div`

`;

const ItemStyled = styled.div`
    position: relative;
    cursor: pointer;
    margin-bottom: 10px;
    border-bottom: 2px solid transparent;
    width: fit-content;
    font-size: 19px;
`;

const ITEMS = [
    {
        title: "firmware.list_of_firmwares",
        type: ASIDE_TYPES.LIST_OF_FIRMWARES
    },
    {
        title: "firmware.upload_firmware",
        type: ASIDE_TYPES.UPLOAD_FIRMWARE
    },
    {
        title: "firmware.sensor_models",
        type: ASIDE_TYPES.SENSOR_MANUFACTURER_TYPE
    }
];

const AsideFirmwareMenu = ({onSelectHandle, selected}) => {
    return (
        <WrapperStyled>
            {ITEMS.map((item, idx) => {
                const isSelected = selected === item.type;

                return (
                    <ItemStyled
                        key={idx}
                        style={isSelected ? {borderColor: colors.CYAN} : {}}
                        onClick={() => {
                            onSelectHandle(item.type);
                        }}
                    >
                        <Tx>{item.title}</Tx>
                    </ItemStyled>
                );
            })}
        </WrapperStyled>
    );
};

export default AsideFirmwareMenu;